import { Component } from '@angular/core';
import { ISidebarNavItem } from '../sidebar/sidebar.interface';
import { ListboxModule } from 'primeng/listbox';

@Component({
  selector: 'app-burger-menu',
  imports: [ListboxModule],
  templateUrl: './burger-menu.html',
  styleUrl: './burger-menu.css',
})
export class BurgerMenu {
  tabs: Pick<ISidebarNavItem, 'name'>[] = [
    { name: 'Tableau de bord' },
    { name: 'Notification' },
    { name: 'Paramètres' },
    { name: 'Support' },
    { name: 'Déconnexion' }
  ];
}
